'use strict';

$(document).ready(function () {
    $(document).on('change', ':file', (e) => {
        let input = e.currentTarget;
        let customFile = $(input).parent();
        let formInput = $(customFile).parent();
        if (formInput.has('.form-input-image-box').length) {
            let fileName = ' ';
            let fileUrl = '';
            let filePreview = 'display: none';
            if (input.files[0]) {
                fileName = input.files[0].name;
                fileUrl = URL.createObjectURL(input.files[0]);
                filePreview = 'display: block';
            }
            customFile.find('.custom-file-label').text(fileName);
            formInput.find('.form-input-image-box .form-input-image').attr('src', fileUrl);
            formInput.find('.form-input-image-box .form-input-image').attr('style', filePreview);
        } else {
            let filesNames = '';
            let files = input.files;
            for (let i = 0; i < files.length; i++) {
                if (filesNames.length) {
                    filesNames += ', ';
                }
                filesNames += files[i].name;
            }
            customFile.find('.custom-file-label').text(filesNames);
        }
    });
});


// WEBPACK FOOTER //
// ./assets/js/utils/fileinput.js